import { Link } from "react-router-dom";
import { HardHat, ArrowLeft } from "lucide-react";

export function SimpleAuthShell({ title, children }) {
  return (
    <div className="min-h-screen bg-white">
      <div className="bg-slate-900 text-white">
        <div className="max-w-md mx-auto px-6 h-16 flex items-center gap-2">
          <span className="w-8 h-8 rounded-md bg-orange-500 grid place-items-center">
            <HardHat className="w-5 h-5 text-slate-900" />
          </span>
          <span className="font-display text-xl font-bold uppercase">Français Chantier</span>
        </div>
        <div className="hazard-stripe h-1.5" />
      </div>
      <div className="max-w-md mx-auto p-6 space-y-5 rise">
        <Link to="/connexion" data-testid="auth-back-to-login" className="inline-flex items-center gap-1 text-sm font-semibold text-slate-600 hover:text-slate-900">
          <ArrowLeft className="w-4 h-4" /> Connexion
        </Link>
        <h1 className="font-display text-3xl font-bold uppercase">{title}</h1>
        {children}
      </div>
    </div>
  );
}

export const primaryBtn =
  "w-full h-14 rounded-xl bg-orange-500 hover:bg-orange-600 active:scale-[.98] text-white font-display text-xl font-bold uppercase transition-[background-color,transform] flex items-center justify-center gap-2 disabled:opacity-60";
